module.exports = __webpack_public_path__ + "media/widget/medication-abc7b61a.png";